function quantityProtection() {
    const attributeKey = 'aantalNamen';
    const urlParams = new URLSearchParams(window.location.search);
    const quantity = Number(urlParams.get('quantity'));

    if (!quantity) {
        return;
    }

    window.expivi._events.onChange.subscribe(event => {
        const payload = event.payload;

        if (event.name !== 'attribute' || payload.attribute_key !== attributeKey) {
            return;
        }

        if (payload.attribute_value.calculated_value > quantity) {
            return window.expivi.setProductAttributeByKey(attributeKey, [{ value: quantity }]);
        }
    });
}

quantityProtection();
